import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

export interface AwardBiddersDialogData {
  invitation_id: number;
  shortlistedBids: { id: number; org_name: string; bid_amount: number }[];
  project_name?: string;
  boq_code?: string;
}

@Component({
  selector: 'app-award-bidders-dialog',
  templateUrl: './award-bidders-dialog.component.html',
  styleUrls: ['./award-bidders-dialog.component.css']
})
export class AwardBiddersDialogComponent {
  selectedIds: Set<number> = new Set();
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<AwardBiddersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AwardBiddersDialogData,
    private apiService: ApiService,
    private toastr: ToastrMsgService
  ) {
    // Pre-select all shortlisted by default
    data.shortlistedBids.forEach(b => this.selectedIds.add(b.id));
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount || 0);
  }

  toggle(bidId: number): void {
    if (this.selectedIds.has(bidId)) {
      this.selectedIds.delete(bidId);
    } else {
      this.selectedIds.add(bidId);
    }
    this.selectedIds = new Set(this.selectedIds);
  }

  isSelected(bidId: number): boolean {
    return this.selectedIds.has(bidId);
  }

  selectAll(): void {
    this.data.shortlistedBids.forEach(b => this.selectedIds.add(b.id));
    this.selectedIds = new Set(this.selectedIds);
  }

  clearAll(): void {
    this.selectedIds.clear();
    this.selectedIds = new Set();
  }

  onAward(): void {
    const ids = Array.from(this.selectedIds);
    if (ids.length === 0) {
      this.toastr.error('Select at least one bidder to award');
      return;
    }
    this.submitting = true;
    this.apiService.createBiddingAward(this.data.invitation_id, ids).subscribe({
      next: (res: any) => {
        this.submitting = false;
        if (res.success) {
          this.toastr.success(res.message || `Awarded to ${res.data?.awards?.length || ids.length} bidder(s)`);
          this.dialogRef.close({ success: true, awards: res.data?.awards });
        } else {
          this.toastr.error(res.error || 'Failed to create award');
        }
      },
      error: (err) => {
        this.submitting = false;
        this.toastr.error(err.error?.error || 'Failed to create award');
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
